import { routes } from './site'

export type ShopCategory = {
  label: string
  href: string
}

export type ShopCategoryGroup = {
  title: string
  categories: (ShopCategory & { body: string })[]
}

/**
 * Single source for online-shop browsing. The /shop landing page, its
 * category jump menu and every category page's sidebar read from here.
 */
export const shopCategoryGroups: ShopCategoryGroup[] = [
  {
    title: 'Filters & Spa Care',
    categories: [
      { label: 'Filters', body: 'Replacement spa filter cartridges.', href: routes.filters },
      {
        label: 'Spa Chemicals',
        body: 'Sanitizers, balancers and clarifiers for spa water.',
        href: routes.spaChemicals,
      },
      {
        label: 'Natural Chemicals',
        body: 'Enzyme and mineral water-care options.',
        href: routes.naturalChemicals,
      },
      {
        label: 'Pool Chemicals',
        body: 'Care products for pool water.',
        href: routes.poolChemicals,
      },
    ],
  },
  {
    title: 'Testing & Care Supplies',
    categories: [
      { label: 'Water Testing', body: 'Test strips and testing kits.', href: routes.testing },
      {
        label: 'Maintenance',
        body: 'Cleaning tools, cover care and upkeep products.',
        href: routes.maintenance,
      },
    ],
  },
  {
    title: 'Grilling',
    categories: [
      {
        label: 'Big Green Egg Accessories',
        body: 'Charcoal, tools and cooking extras for the EGG.',
        href: routes.bigGreenEggAccessories,
      },
    ],
  },
]

/** Flat category list used by category-page navigation. */
export const shopCategories: ShopCategory[] = shopCategoryGroups.flatMap((group) =>
  group.categories.map(({ label, href }) => ({ label, href })),
)
